<template>
  <div class="breadcarst mc-flex mc-mtb-20 mc-size12">
    <div v-for="(item, index) in breadData" :class="index !== breadData.length - 1 ? 'gray9-text' : ''" :key="index">
      <i class="el-icon-arrow-right" v-if="index !== 0"></i>
      <router-link class="gray9-text" :to="item.src" v-if="item.link">{{item.text}}</router-link>
      <span v-else>{{item.text}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["breadData"],
  data() {
    return {};
  },

  // components: {},

  // computed: {},

  // mounted: {},

  // methods: {}
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
</style>



// WEBPACK FOOTER //
// src/components/Breadcarst.vue